import { getCookie } from 'utils/auxiliary'

import axios from 'axios'
import CryptoJS from 'crypto-js'

const DEFAULT_API_ORIGIN = process.env.REACT_APP_URL_API || ''
const DEBUG_SIG = (process.env.REACT_APP_DEBUG_SIG || 'true') === 'true'

const SIG_API_KEY = process.env.REACT_APP_SIG_API_KEY
const SIG_SECRET = process.env.REACT_APP_SIG_SECRET

function absoluteTargetFromConfig(config) {
  const url = config.url || ''
  const isAbsolute = /^https?:\/\//i.test(url)
  if (isAbsolute) return url
  const base = (config.baseURL || axios.defaults.baseURL || '').replace(/\/$/, '')
  const path = url.startsWith('/') ? url : `/${url}`
  return `${base}${path}`
}
function rid() {
  return Math.random().toString(36).slice(2, 8)
}

function buildLocalSignature() {
  const timestamp = Date.now().toString()
  const apiKeyHash = CryptoJS.SHA256(SIG_API_KEY + timestamp).toString()
  const secretHash = CryptoJS.SHA256(SIG_SECRET + timestamp).toString()
  const signatureHash = CryptoJS.SHA256(SIG_API_KEY + SIG_SECRET + timestamp).toString()
  const signature = `${signatureHash}:${timestamp}`
  return { apiKeyHash, secretHash, signature, timestamp }
}

let interceptorsInstalled = false
let isLoggingOut = false

export function setupAxiosInterceptors() {
  if (interceptorsInstalled) return
  interceptorsInstalled = true

  axios.defaults.baseURL = DEFAULT_API_ORIGIN
  axios.defaults.withCredentials = true

  axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
  axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

  axios.interceptors.request.use(
    async config => {
      const target = absoluteTargetFromConfig(config)
      const skip = config.headers && config.headers['x-skip-sign'] === '1'
      const id = rid()
      const jwt = getCookie('jwt')
      if (jwt) {
        // axios no manda esta cookie solo, salvo que el back la haya seteado como HttpOnly
        config.headers['Cookie'] = `jwt=${jwt}`
      }

      // if (DEBUG_SIG) console.log(`[REQ ${id}] -> ${target}${skip ? ' (skip-sign)' : ''}`)

      if (!skip) {
        const sig = buildLocalSignature()
        const SIG_HEADERS = {
          'x-apikey': sig.apiKeyHash,
          'x-secret': sig.secretHash,
          'x-signature': sig.signature,
          // app: process.env.NODE_ENV || 'development',
        }
        config.headers = { ...(config.headers || {}), ...SIG_HEADERS }
        config.withCredentials = true

        // if (DEBUG_SIG) console.log(`[REQ ${id}] headers inyectados`, SIG_HEADERS)
      }

      return config
    },
    err => {
      // if (DEBUG_SIG) console.error('[REQ] interceptor error', err)
      return Promise.reject(err)
    }
  )

  axios.interceptors.response.use(
    res => res,
    err => {
      const status = err?.response?.status
      const isUnauthorized = status === 401
      const isInLoginPage = typeof window !== 'undefined' && window.location?.pathname === '/login'

      if (DEBUG_SIG) {
        const cfg = err?.config
        // console.error('[RES ERR]', status, cfg?.url, err?.message)
      }

      if (isUnauthorized && !isLoggingOut && !isInLoginPage) {
        isLoggingOut = true
        const logoutUrl = `${(axios.defaults.baseURL || '').replace(/\/$/, '')}/logout`
        axios
          .post(
            logoutUrl,
            {},
            {
              withCredentials: true,
              headers: { 'x-skip-sign': '1' },
            }
          )
          .catch(() => {})
          .finally(() => {
            try {
              localStorage.clear()
              sessionStorage.clear()
            } catch (_) {}
            if (typeof window !== 'undefined') window.location.replace('/login')
          })
      }
      return Promise.reject(err)
    }
  )
}
